import React, { useLayoutEffect, useRef } from "react";
import { OrgChart } from "d3-org-chart";
import { select } from "d3-selection"; // Import select from d3-selection
import "./OrganizationChart.css";

export const OrgChartComponent = (props) => {
  const d3Container = useRef(null);
  let chart = null;

  useLayoutEffect(() => {
    if (props.data && d3Container.current) {
      if (!chart) {
        chart = new OrgChart();
      }

      const numGrandchildren = props.data.reduce(
        (sum, node) => sum + (node.id != null),
        2
      );

      const containerHeight = numGrandchildren * 150; // Adjust as needed

      // Set the height of the chart container
      // d3Container.current.style.height = `${containerHeight}px`;

      chart
        .container(d3Container.current)
        .data(props.data)
        .nodeWidth((d) => 300)
        .nodeHeight((d) => 150)
        .onNodeClick((d) => {
          props.onNodeClick(d);
        })
        .buttonContent(({ node, state }) => {
          return "";
        })
        .nodeContent((d) => {
          const color = "white";
          return `
          <div class="card text-dark" style="font-family: 'Inter', sans-serif; background-color: ${color}; border-radius: 10px; border: 1px solid #2755F3;">
          <div class="card-body position-relative" style="padding: 10px;">
              <div class="position-absolute top-2 start-2" style="top: 10px; left: 10px;">
                  <i class="fa fa-user" style="font-size: 18px; color: white; background-color: #2755F3; border-radius: 50%; padding: 8px;"></i>
              </div>
              <div class="ms-5 text-primary" >
                  <div class="text-muted mb-1" style="font-size: 12px; color:'black'"><span class="fw-bold text-dark">Name : </span><span class="text-dark">${d.data.name}</span></div>
                  <div class="text-muted mb-1" style="font-size: 12px;"><span class="fw-bold text-dark">Employee Code : </span><span class="text-dark">${d.data.eid}</span></div>
                  <div class="text-muted mb-1" style="font-size: 12px;"> <span class="fw-bold text-dark">Designation : </span><span class="text-dark">${d.data.designation}</span></div> 
                  <div class="text-muted mb-1" style="font-size: 12px;"><span class="fw-bold text-dark">Vertical : </span><span class="text-dark">${d.data.costCenter}</span></div>
                  <div class="text-muted mb-1" style="font-size: 12px;"><span class="fw-bold text-dark">Location : </span><span class="text-dark">${d.data.location}</span></div>
                  <div class="text-muted mb-1" style="font-size: 12px;"><span class="fw-bold text-dark">Email : </span><span class="text-dark"><a href="mailto:${d.data.email}" >${d.data.email}</a></span></div>
                  <div class="text-muted mb-1" style="font-size: 12px;"><span class="fw-bold text-dark">Contact Number : </span><span class="text-dark"><a href="tel:${d.data.contactNumber}" >${d.data.contactNumber}</a></span></div> 
              </div>
          </div>
      </div>
      
          `;
        })
        .expandAll()
        .render();

      // Increase the height of svg-chart-container
      select(d3Container.current)
        .select(".svg-chart-container")
        .attr("height", containerHeight);
    }
  }, [props.data, d3Container.current]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div ref={d3Container} className="chart-container" />
        </div>
      </div>
    </div>
  );
};
